export const UcdSubmitType = {
  UCD: 'Ucd',
  LCA: 'Lca',
};
